import hekateBus from '../../bus';

type CadPlanGroup =
  | 'Free'
  | 'Pro'
  | 'Other'
  | 'Enterprise'
  | 'Pro Trial'
  | 'Standard'
  | 'EDU Enterprise'
  | 'EDU Standard'
  | 'EDU Educator';

type CadPlanId =
  | 'PRO_COMPANY_TRIAL'
  | 'FREE_2016'
  | 'PRO_DISCOVERY'
  | 'EDU_YEARLY'
  | 'EDU_EDUCATOR'
  | 'STANDARD_YEARLY';

/** type is mirrored on bundle */
type SSOInfo = {
  planGroup: CadPlanGroup;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  image: string | null;
  extraData: {
    industry?: string;
    persona?: string;
    jobTitleNormalized?: string;
    currentCADSystem?: string;
    productSkuAtSignup?: string;
    csmName?: string;
    csmEmail?: string;
    isEmailPreferencesSet?: boolean;
    isSubPremiumContent?: boolean;
    isSubNewsletter?: boolean;
    isSubEvents?: boolean;
    isSubBlogs?: boolean;
    productSku?: string;
    daysLeftInTrial?: string;
    numberOfExports?: string;
    numberOfImports?: string;
    stlImportsExports?: string;
    hasCompletedAnyTraining?: string;
    hasStartedAnyTraining?: string;
    uUsageTimeL30D?: string;
  };
  currentUserData: {
    activePlanId: CadPlanId; // active plan is different if using company provided plan
    activePlanGroup: CadPlanGroup;
    ownPlanId: CadPlanId; // purchased by the individual
    ownPlanGroup: CadPlanGroup;
    companyPurchasePlanId: CadPlanId;
    companyPurchasePlanGroup: CadPlanGroup;
    uid: string;
  };
};

type SSOInfoResponse = {
  isReady: boolean;
  ssoInfo: SSOInfo | null;
};

/** Utility class for SSO login data */
export default class SSOUtil {
  private ssoData: Promise<SSOInfo | null>;

  constructor() {
    // wait for the sso data to be ready and set its value
    this.ssoData = new Promise((res) => {
      let tries = 50;
      const interval = setInterval(() => {
        hekateBus.dispatchEvent('request-sso-info', {});
        tries -= 1;
        if (tries < 1) {
          clearInterval(interval);
        }
      }, 200);

      hekateBus.addEventListener('sso-info', (info: { data: SSOInfoResponse }) => {
        if (!info.data.isReady) {
          return;
        }
        clearInterval(interval);
        res(info.data.ssoInfo || null);
      });
    });
  }

  /** get sso data when it is ready, null if the user is not logged in */
  public getSsoData(): Promise<SSOInfo | null> {
    return this.ssoData;
  }
}
